module.exports = __webpack_public_path__ + "img/expostyle_0956_buff_pantone7504c.c7d0e726.jpg";